export default {
  MinDate: '{name} باید قبل بعد از {min} باشد',
  MaxDate: '{name} باید قبل از {max} باشد',
  digit: '{name} should be digit',
  carSelectionIsRequired: 'car selection is required',
  packageSelectionIsRequired: 'package selection is required',
  required: '{field} is required',
  min: '{field} must have at least {length} characters',
  max: '{field} must have a maximum of {length} characters',
  length: '{fiels} must be exactly {length} characters',
  minValue: 'The value of {field} cannot be less than {value}',
  maxValue: 'The value of {field} cannot be more than {value}',
  notValid: '{field} is not valid',
  confirmed: 'Then value of {field} should equal to {source}',
  registerOrderInterval:
    '{field} must be at least {intervalHours} hours after current time',
  carLaborerCount: {
    min: 'Minumum count of laborer for {carTitle} is {count}'
  },
  carSelectionIsRequired: 'Selecting at least one car is required to continue',
  packageSelectionIsRequired:
    'Selecting at least one package is required to continue',
  technicalForceSelectionIsRequired:
    'Selecting at least one technical force is required to continue'
}
